import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Button, TextField } from "@material-ui/core/";
import Autocomplete from "@material-ui/lab/Autocomplete";
import cookie from "react-cookies";
import {
  getAuditedListByUser,
  fetchQATranscriptionAudio,
  setPageName,
  superQAAudioDecision,
  fetchRejectReajonList,
  saveKeywordSuggestions,
  fetchProducts,
  fetchUserLanguages,
  saveKeyword,
} from "../../../service/action/audio-track-action";
import { Loader } from "../../../Components";

class CreateKeyword extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchValue: "",
      keywordText: "",
      seletedLanguage: "",
      keywordErrorText: "",
    };
    this.handleSearchValueChange = this.handleSearchValueChange.bind(this);
  }

  componentWillMount() {
    this.props.setPageName("Keyword Generator");
    this.props.fetchUserLanguages();
    this.props.fetchProducts();
  }

  handleKeywordCreate() {
    const { searchValue, keywordText, seletedLanguage } = this.state;
    console.log(searchValue, keywordText, seletedLanguage);
    this.props.saveKeyword(
      cookie.load("username"),
      searchValue.toString(),
      seletedLanguage,
      keywordText
    );
  }

  handleKeywordText(e) {
    e.preventDefault();
    console.log(e.target.value);
    let keywordValue = e.target.value;
    var format = /^[a-zA-Z][a-zA-Z ]*$/;
    console.log(format.test(keywordValue));
    if (format.test(keywordValue) === true) {
      this.setState({
        keywordText: keywordValue,
        keywordErrorText: "",
      });
    } else {
      this.setState({
        keywordText: "",
        keywordErrorText:
          "Only Alphabets and Space allowed. Numbers means Use like Ex: one, two etc.",
      });
    }
  }

  handleSearchValueChange(event, value) {
    event.preventDefault();
    const {
      SuperAdminReducer: { userProducts },
    } = this.props;
    console.log(userProducts);
    console.log(value);
    const userObj =
      (userProducts &&
        userProducts.find((element) => element.Productdesc === value)) ||
      null;
    if (userObj === null) {
      this.setState({ searchValue: "" });
    } else {
      this.setState({ searchValue: userObj.ProductId });
    }
  }

  render() {
    const {
      CreatorDashboardReducer: { loading, keywordCreate },
      SuperAdminReducer: { userProducts, userLanguages },
    } = this.props;
    const { keywordText, searchValue, seletedLanguage, keywordErrorText } =
      this.state;
    console.log(seletedLanguage);
    console.log(searchValue);
    console.log(keywordText);
    console.log(keywordCreate);

    return (
      <div className="audio-to-trans-page superqa_team">
        <div className="audio-result-contnet keyword-suggestions-container">
          <div className="text-center">
            <Autocomplete
              onChange={(event, newValue) =>
                this.handleSearchValueChange(event, newValue)
              }
              id="controllable-states-demo"
              options={
                userProducts && userProducts.length > 0
                  ? userProducts.map((option) => option.Productdesc)
                  : []
              }
              style={{ width: "100%" }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select Product..."
                  style={{ width: "80%", marginTop: "-20px" }}
                />
              )}
            />
          </div>
          <br />
          <br />
          <br />
          <div className="text-center">
            <Autocomplete
              onChange={(event, newValue) =>
                this.setState({
                  seletedLanguage: newValue,
                })
              }
              id="controllable-states-demo1"
              options={userLanguages}
              style={{ width: "100%" }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select Language..."
                  style={{ width: "80%", marginTop: "-20px" }}
                />
              )}
            />
          </div>
          <br />
          <br />
          <div className="text-center">
            <TextField
              id="standard-basic"
              label="Type Keyword Here..."
              // onChange={(e) =>
              //   this.setState({
              //     keywordText: e.target.value,
              //   })
              // }
              onChange={(e) => this.handleKeywordText(e)}
              style={{ width: "80%" }}
            />
          </div>
          {keywordErrorText && (
            <p
              style={{
                display: "flex",
                color: "red",
                justifyContent: "center",
                fontSize: 22,
              }}
            >
              {" "}
              {keywordErrorText}
            </p>
          )}
          <br />
          <br />
          <div className="btn-wrapper text-center">
            <Button
              disabled={
                searchValue === "" ||
                keywordText === "" ||
                seletedLanguage === ""
              }
              onClick={() => this.handleKeywordCreate()}
              variant="contained"
              color="primary"
            >
              Submit
            </Button>
          </div>
          <br />
          <br />
          <br />
          {loading && <Loader />}
          {keywordCreate &&
            keywordCreate.data[0] &&
            (keywordCreate.data[0].Status === 0 ? (
              <p
                style={{
                  display: "flex",
                  color: "#008000",
                  justifyContent: "center",
                  fontSize: 22,
                }}
              >
                {" "}
                {keywordCreate.data[0].Statusdesc}
              </p>
            ) : (
              <p
                style={{
                  display: "flex",
                  color: "red",
                  justifyContent: "center",
                  fontSize: 22,
                }}
              >
                {" "}
                {keywordCreate.data[0].Statusdesc}
              </p>
            ))}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { userLogin, CreatorDashboardReducer, SuperAdminReducer } = state;

  return {
    SuperAdminReducer,
    CreatorDashboardReducer,
    userLogin,
  };
}

export default withRouter(
  connect(mapStateToProps, {
    fetchUserLanguages,
    fetchProducts,
    getAuditedListByUser,
    fetchQATranscriptionAudio,
    setPageName,
    superQAAudioDecision,
    fetchRejectReajonList,
    saveKeywordSuggestions,
    saveKeyword,
  })(CreateKeyword)
);
